export const MIN_DIMENSION_SIZE = 0.5;
export const MIN_DIMENSION_PUFF = {
  width: 3,
  height: 2
};

export const DEFAULT_SIZE = 1;
export const MIN_DPI = 200;
export const PRINT_AS_IS_MIN_DPI = 300;
export const PRINT_AS_IS_MAX_HEIGHT = 20; // PRINT_AS_IS_MAX_HEIGHT in feet
export const PRINT_AS_IS_MIN_WIDTH = 22;
export const GANG_SHEET_PIXELS_IN_INCH = 300;
export const GANG_SHEET_REQUIRED_WIDTH_INCHES = 22;
export const GANG_SHEET_REQUIRED_WIDTH_PX =
  GANG_SHEET_PIXELS_IN_INCH * GANG_SHEET_REQUIRED_WIDTH_INCHES; // 6600px
export const GANG_SHEET_MIN_HEIGHT_INCHES = 24;
export const GANG_SHEET_MIN_HEIGHT_PX = GANG_SHEET_PIXELS_IN_INCH * GANG_SHEET_MIN_HEIGHT_INCHES; // 7200px
export const GANG_SHEET_WIDTH_ERROR = "gang_sheet_width_error";
export const GANG_SHEET_HEIGHT_ERROR = "gang_sheet_height_error";
export const PDP_TYPE_GANG_SHEETS = "gang_sheets";
export const MAX_SIZE_FIELD_VALUE = 300;
export const UPSCALE_THRESHOLD = 10; // new width/height should not exceed 10 times the original width/height
export const MAX_QUANTITY_VALUE = 9999;
export const INCHES_PER_FOOT = 12;

// NOTE: The default width and height values here should also reflect in
// Dtf::PdpDefaultValues. Remember to update the values in the service class if any changes
// to the default size / quantity has to be made. This is need to make sure we are passing
// the correct landing page pricing to Google Merchant Center.
//   * dimensions
//   * quantities
export const GANG_DEFAULT_VALUES = Object.freeze({
  width: 22,
  height: 2,
  lengthFoot: 2,
  quantity: 1,
  previewMetadata: { heightInch: 24 }
});

export const DEFAULT_PUFF_VALUES = Object.freeze({
  image: null,
  width: 3,
  height: 3,
  quantity: 10
});

export const JERSEY_NUMBERS_DEFAULT_VALUES = Object.freeze({ width: 4, height: 4, quantity: null });

export const DEFAULT_VALUES = Object.freeze({
  width: DEFAULT_SIZE,
  height: DEFAULT_SIZE,
  quantity: 1
});

export const LETTER_DEFAULTS = {
  font: null,
  maxLength: null,
  showCustomHeight: false,
  showCustomMaxLength: false,
  texts: []
};

export const LETTERS_FILL_IN_VALUES = {
  style: "straight",
  font: "promesh",
  max_length_inch: 9,
  letter_height_inch: 2,
  color: "#000000",
  texts: ["ABCD"],
  quantity: 1
};

export const RETRY_INTERVALS = [
  1000, 1000, 1000, 1000, 1000, 5000, 5000, 5000, 5000, 5000, 10000, 10000, 10000, 10000, 10000
];

// These keys needed to be kept as snakecase on mixpanel
export const MIXPANEL_METADATA_KEYS = [
  "font_details",
  "total_images",
  "total_texts",
  "total_shapes",
  "enhancements"
];

export const GOLD_FOIL_HEX = "#FFD700";

export const MAX_PRINT_SIZES_GROUPED = {
  custom: [],
  "full-front": [
    { category: "adult", sizeRange: "XS - S", width: 10, height: 12 },
    { category: "adult", sizeRange: "M - L", width: 11, height: 14 },
    { category: "adult", sizeRange: "XL", width: 12, height: 14 },
    { category: "adult", sizeRange: "XXL+", width: 13, height: 15 },
    { category: "youth", sizeRange: "XS - S", width: 7, height: 7 },
    { category: "youth", sizeRange: "M - L", width: 8, height: 8 },
    { category: "youth", sizeRange: "XL", width: 9, height: 9 },
    { category: "toddler", sizeRange: "5T - 6T", width: 6, height: 6 },
    { category: "toddler", sizeRange: "2T - 4T", width: 5, height: 5 },
    { category: "infant", sizeRange: "6M - 24M", width: 4, height: 4 },
    { category: "infant", sizeRange: "Newborn", width: 3, height: 3 }
  ],
  "full-back": [
    { category: "adult", sizeRange: "XS - M", width: 10, height: 13 },
    { category: "adult", sizeRange: "L+", width: 12, height: 15 },
    { category: "youth", sizeRange: "XS - S", width: 9, height: 12 },
    { category: "youth", sizeRange: "M+", width: 10, height: 13 },
    { category: "toddler", width: 8, height: 10 },
    { category: "infant", width: 6, height: 8 }
  ],
  "left-chest": [
    { category: "adult", sizeRange: "XS - M", width: 3, height: 3 },
    { category: "adult", sizeRange: "L+", width: 3.5, height: 3.5 },
    { category: "youth", sizeRange: "XS - M", width: 2.75, height: 2.75 },
    { category: "youth", sizeRange: "L+", width: 3, height: 3 },
    { category: "toddler", width: 2, height: 2 },
    { category: "infant", width: 1.5, height: 1.5 }
  ],
  sleeve: [
    { category: "adult", sizeRange: "XS - S", width: 2.5, height: 2.5 },
    { category: "adult", sizeRange: "M - XL", width: 3, height: 3 },
    { category: "adult", sizeRange: "XXL+", width: 3.25, height: 3.25 },
    { category: "youth", width: 2.5, height: 2.5 },
    { category: "toddler", width: 2.25, height: 2.25 },
    { category: "infant", width: 1.5, height: 1.5 }
  ],
  "back-collar": [
    { category: "adult", sizeRange: "XS - L", width: 3, height: 3 },
    { category: "adult", sizeRange: "L+", width: 3.5, height: 3.5 },
    { category: "youth", width: 2.5, height: 2.5 },
    { category: "toddler", width: 2, height: 2 },
    { category: "infant", width: 1.75, height: 1.75 }
  ]
};

export const PRESET_MOCKUP_COLORS = [
  { name: "Black", value: "#000000", isModalColor: false },
  { name: "White", value: "#FFFFFF", isModalColor: false },
  { name: "Gray", value: "#BDBBBC", isModalColor: false },
  { name: "Pink", value: "#F7C9D4", isModalColor: false },
  { name: "Red", value: "#D3113B", isModalColor: false },
  { name: "Navy", value: "#031A41", isModalColor: false },
  { name: "Light brown", value: "#EDE4D3", isModalColor: true },
  { name: "Dark brown", value: "#D8C6AF", isModalColor: true },
  { name: "Blue", value: "#106CB1", isModalColor: false }
];

export const MIN_STICKER_SIZE = 3;

export const UPLOAD_BUTTON_LABEL = "My Device";
export const ARTWORK_IMAGE_MESSAGES = {
  transfers: [
    "Make those neons & gradients pop - try ProColor! 🎨",
    "Thin lines? Keep ’em at least 0.25 inches thick! ✏️",
    "Transparent backgrounds = Instant magic! 🌟",
    "Small fonts? Use 7.5px minimum! 🔍",
    "Jiffy Transfers: Blink and they’re done! ⏱️",
    "Heat press, peel when cool ❄️",
    "Machine wash inside out for a long-lasting love affair 👕",
    "Glossy finish? Teflon’s got you covered! ✨",
    "Matte finish? Parchment paper to the rescue! 💪",
    "Cotton and fabric blends love Jiffy Transfers 😍",
    "Add sparkle with glitter transfers! ✨",
    "Royal touch? Go for gold foil! 👑",
    "Get some night-time bling with glow-in-the-dark transfers! 🌙",
    "Reflective prints for safety and style! 🚸",
    "Thermochromic designs react to heat! 🔥",
    "Pearl prints add a blue-green sheen! 🦚",
    "Pre-press to keep it wrinkle-free 🧺",
    "Jiffy transfers: No weeding, more speed! ⏳",
    "Use SVG for scalable vector designs 📐",
    "Optimized for PNG files 🎉",
    "Tumble dry low and keep the prints pro! 🔄",
    "Bold designs with reflective or foil transfers! 😎",
    "High polyester blends? Try sublimation! 🧪",
    "Intricate designs made easy with Jiffy Transfers 🥳",
    "No setup costs, just print and press! 🤑",
    "No minimum orders, because why limit creativity? 💸",
    "Save time, save money, press in seconds 💰",
    "Photo-quality prints with ProColor magic 🪄",
    "Save time, grow your business with Jiffy Transfers 📈",
    "Ultra-durable prints, shipped same-day! 📦",
    "Softer to touch than HTV 💅",
    "Print on more fabrics than ever before 🤩",
    "No equipment to maintain with Jiffy Transfers, just bring the heat! 🔥"
  ],
  stickers: [
    "Dark backgrounds are perfect for your white designs 🕶️",
    "No email proofing needed, your stickers will print exactly as previewed ✉️",
    "High-quality and durable stickers, delivered as soon as tomorrow 💨",
    "The more you buy, the cheaper each sticker will be 🤑",
    'You can get 100 2" stickers for only $25! ✓',
    "Die-cut stickers follow the exact contour of your image 📏",
    "Our high quality vinyl makes it easy to peel and apply 🪶",
    "Jiffy stickers are the perfect gift to delight your customers 🙂",
    "Convert your transfers into die-cut stickers to complete your project 🔁",
    "Customize your border size and background color in 1 click 🖱️"
  ]
};

// SingleImageZoom constants
export const SINGLE_IMAGE_ZOOM = Object.freeze({
  NATURAL_HEIGHT_THRESHOLD: 1000,
  DEFAULT_IMAGE_HEIGHT: "80vh",
  STICKER_MAX_HEIGHT: "60vh",
  INLINE_MAX_HEIGHT: "50vh",
  FULL_WIDTH_IMAGE_WIDTH: "90vw"
});

export const BACKGROUND_TYPES = { CHECKERED: "checkered", GREEN: "green" };

// DTF catalog number constants
export const DTF001_CATALOG_NUMBER = "DTF001";

// Polling enabled catalog numbers
export const POLLING_ENABLED_CATALOG = Object.freeze(["DTF001"]);
// Backend triggered enhancement eligible catalog numbers
export const BACKEND_TRIGGERED_ENHANCEMENT_ELIGIBLE_CATALOG = Object.freeze(["DTF001"]);
